//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import * as d3 from 'd3'
import * as chroma from 'chroma-js'
import * as Honeycomb from 'honeycomb-grid'
import SVG from 'svg.js'
import * as pointInSvgPolygon from 'point-in-svg-polygon'

function getLiveData () {
    let url = "http://influxdb.passivelogic.com:8086/query?q=select+*+from+sensor+group+by+label+order+by+desc+limit+1&db=FILLINGIM"
    return fetchSrc(url, text => {
        let mapping = {
            "ATMstBed": ["MasterBedroomFloorTemperature"],
            "ATVMstBd": ["MasterBedroomCeilingTemperature"],
            "ATBed1"  : ["StudyAirTemperature"],
            "ATVGrtRm": ["GreatRoomCeilingTemperature"],
            "ATGrtRm" : ["GreatRoomAirTemperature"],
            "FTGrtRm" : ["GreatRoomFloorTemperature"],
//            "ATOut"    : [
//                "OutsideAirTemperature1",
//                "OutsideAirTemperature2",
//                "OutsideAirTemperature3",
//                "OutsideAirTemperature4"
//            ]
        }
        let obj = JSON.parse(text)
        let results = obj['results']
        let newValues = {}
        if (results.length == 1) {
            let series = results[0]['series']
            series.forEach(entry => {
                let values = entry['values'][0]
                let name = entry['tags']['label']
                let value = values[1]
                let keys = mapping[name]
                if (keys) {
                    keys.forEach(key => {
                        newValues[key] = value
                    })
                }
            })
            return newValues
        }
    })
}

function sleep (time) {
    return new Promise((resolve) => setTimeout(resolve, time));
}

function sineWave(x, amplitude, frequency, phase=0, vertical=null, debug=false) {
    let a = amplitude
    let b = 2 * Math.PI * frequency
    let c = phase
    let d = vertical
    if (vertical === null) {
        d = amplitude
    }
    let result = a * Math.sin(b * (x + c)) + d
    if (debug) {
        console.log(result)
    }
    return result
}

// Find the nearest 'num' sensors
function closest(x, y, sensors, num=3) {
    let distances = []
    sensors.forEach((sensor, idx) => {
        if (sensor.cx !== null && sensor.cy !== null && sensor.value !== null) {
            let dx = Math.abs(sensor.cx - x)
            let dy = Math.abs(sensor.cy - y)
            let distance = Math.sqrt(dx * dx + dy * dy)
            distances.push({sensor: sensor, distance: distance})
        }
    })
    distances.sort((a, b) => {
        if (a.distance > b.distance) return 1
        if (b.distance > a.distance) return -1
    })

    // If we don't have the requested number of points, use all the ones that
    // we have.
    if (distances.length < num) {
        num = distances.length
    }

    return distances.slice(0, num)
}

// Perform an inverse distance weighting interpolation of the sensor values
function inverseDistanceWeighting(hexagon, sensors, power=1.5) {
    let A = 0.0
    let B = 0.0
    hexagon.closest.forEach(sensor => {
        if (sensor.distance == 0.0) {
            A = sensor.sensor.value
            B = 1.0
            return
        }
        else {
            let w = 1.0 / Math.pow(sensor.distance, power)
            A += w * sensor.sensor.value
            B += w
        }
    })
    return A / B
}

// Download a file
function fetchSrc(src, onFetch) {
    return fetch(src)
        .then(response => {
            return response.text()
        })
        .then(text => {
            return onFetch(text)
        })
}

let scale = chroma
    .scale([
        "#2c7bb6",
        "#00a6ca",
        "#00ccbc",
        "#90eb9d",
        "#ffff8c",
        "#f9d057",
        "#f29e2e",
        "#e76818",
        "#d7191c"
    ])
    .domain([0.0, 0.125, 0.25, 0.375, 0.50, 0.625, 0.75, 0.875, 1.00])

function createScaleLegend(svgId) {
    let svg = d3.select("#" + svgId).append("svg").attr("width", "100%")
    svg.append("defs")
        .append("linearGradient")
        .attr("id", "legendGradientMulti")
        .attr("x1", "0%").attr("y1", "0%")
        .attr("x2", "100%").attr("y2", "0%")
        .selectAll("stop")
        .data([
            {offset: "0%"   , color: "#2c7bb6"},
            {offset: "12.5%", color: "#00a6ca"},
            {offset: "25%"  , color: "#00ccbc"},
            {offset: "37.5%", color: "#90eb9d"},
            {offset: "50%"  , color: "#ffff8c"},
            {offset: "62.5%", color: "#f9d057"},
            {offset: "75%"  , color: "#f29e2e"},
            {offset: "87.5%", color: "#e76818"},
            {offset: "100%" , color: "#d7191c"} ])
        .enter().append("stop")
        .attr("offset", function(d) { return d.offset; })
        .attr("stop-color", function(d) { return d.color; })
        .attr("stop-opacity", 0.5)

    let scaleGroup = svg.append("svg")
        .attr("x", "5%").attr("y", "95%")
        .attr("width", "20%").attr("height", 40)
        .attr("overflow", "visible")

    scaleGroup.append("text").attr("x", "50%").attr("y", -4).style("font-family", "sans-serif").style("font-size", "16px").attr("alignment-baseline", "ideographic").attr("text-anchor", "middle").text("Air Temperature (F)")
    scaleGroup.append("rect")
        .attr("width", "100%").attr("height", "50%")
        .style("fill", "url(#legendGradientMulti)")

    scaleGroup.append("text").attr("x",    "0%").attr("y", 28).style("font-family", "sans-serif").style("font-size", "10px").attr("alignment-baseline", "hanging").attr("text-anchor", "left").text("60")
    scaleGroup.append("text").attr("x", "14.3%").attr("y", 28).style("font-family", "sans-serif").style("font-size", "10px").attr("alignment-baseline", "hanging").attr("text-anchor", "middle").text("64.3")
    scaleGroup.append("text").attr("x", "28.6%").attr("y", 28).style("font-family", "sans-serif").style("font-size", "10px").attr("alignment-baseline", "hanging").attr("text-anchor", "middle").text("68.6")
    scaleGroup.append("text").attr("x", "42.9%").attr("y", 28).style("font-family", "sans-serif").style("font-size", "10px").attr("alignment-baseline", "hanging").attr("text-anchor", "middle").text("72.9")
    scaleGroup.append("text").attr("x", "57.1%").attr("y", 28).style("font-family", "sans-serif").style("font-size", "10px").attr("alignment-baseline", "hanging").attr("text-anchor", "middle").text("77.1")
    scaleGroup.append("text").attr("x", "71.4%").attr("y", 28).style("font-family", "sans-serif").style("font-size", "10px").attr("alignment-baseline", "hanging").attr("text-anchor", "middle").text("81.4")
    scaleGroup.append("text").attr("x", "85.7%").attr("y", 28).style("font-family", "sans-serif").style("font-size", "10px").attr("alignment-baseline", "hanging").attr("text-anchor", "middle").text("85.7")
    scaleGroup.append("text").attr("x",   "97%").attr("y", 28).style("font-family", "sans-serif").style("font-size", "10px").attr("alignment-baseline", "hanging").attr("text-anchor", "right").text("90")
}

class Heatmapper {
    #drawing;
    #values;
    #svgId;
    #hexagons = [];

    #sensors = {
        "MasterBedroomFloorTemperature"     : {cx: null, cy: null, value: 60},
        "MasterBedroomCeilingTemperature"   : {cx: null, cy: null, value: 65},
        "StudyAirTemperature"               : {cx: null, cy: null, value: 70},
        "GreatRoomCeilingTemperature"       : {cx: null, cy: null, value: 75},
        "GreatRoomAirTemperature"           : {cx: null, cy: null, value: 80},
        "GreatRoomFloorTemperature"         : {cx: null, cy: null, value: 85},
        "OutsideAirTemperature1"            : {cx: null, cy: null, value: null},
        "OutsideAirTemperature2"            : {cx: null, cy: null, value: null},
        "OutsideAirTemperature3"            : {cx: null, cy: null, value: null},
        "OutsideAirTemperature4"            : {cx: null, cy: null, value: null}
    }
    #interpolatedValues = {}

    gridLabelsEnabled = false
    sensorGlyphsEnabled = false
    gridColorsEnabled = true
    gridAnimateColorsEnabled = false
    liveUpdatePeriod = 3000
    #gridWidth = 50
    #gridStyle = "flat"
    #liveDataSource = "none"
    #jobId = null

    #animationDuration = 2000
    #animationCycleCount = 0
    interpolatePower = 1.5

    constructor(svgId, width=50) {
        this.#gridWidth = width
        this.#svgId = svgId
        this.#drawing = SVG(svgId).size('95%', '100%')
    }

    get width() {
        return this.#gridWidth
    }

    set width(newWidth) {
        this.#gridWidth = newWidth
    }

    updateSensors(newValues) {
        let didUpdate = false
        for (const name in newValues) {
            let value = newValues[name]
            if (value != -99) {
                if (this.#sensors[name].value != value) {
                    didUpdate = true
                }
                this.#sensors[name].value = value
            }
        }
        return didUpdate
    }

    addSensorGlyphs() {
        let sensorGlyphGroup = this.#drawing.select('#HeatMapSensorGlyphs').first()
        for (const name in this.#sensors) {
            let sensor = this.#sensors[name]
            let value = sensor.value
            let scaledValue = this.scaleValue(value, 60.0, 90.0)
            let color = this.scaleColor(value, 60.0, 90.0)
            if (value !== null) {
                let marker = sensorGlyphGroup.group()
                    .attr('id', name + 'Glyph')
                    .attr('pl-type', 'glyph')
                marker.circle(35)
                    .cx(sensor.cx).cy(sensor.cy)
                    .fill(color)
                    .attr("stroke-width", 0.5)
                    .attr("stroke", "black")
                marker.plain(value.toFixed(1))
                    .font({
                        'font-size': 'x-small',
                        'dominant-baseline': 'central',
                        anchor: 'middle'
                    })
                    .translate(sensor.cx, sensor.cy)
            }
        }
    }

    delSensorGlyphs() {
        let glyphs = this.#drawing.select('*[pl-type="glyph"]')
        glyphs.each(function () {
            this.remove()
        })
    }

    addGrid() {
    }

    delGrid() {
    }

    findSensors() {
        let that = this
        // Read the sensor positions from the markers in the SVG
        let sensorGlyphGroup = this.#drawing.select('#HeatMapSensorGlyphs').first()
        let sensorMarkers = this.#drawing.select('*[pl-type="sensor"]')
        sensorMarkers.each(function () {
            let cx = this.cx()
            let cy = this.cy()
            let name = this.id()
            let value = that.#sensors[name].value
            if (value !== null) {
                that.#sensors[name] = {cx: cx, cy: cy, value: value}
                this.hide()
            }
            else if (value === null) {
                this.hide()
            }
            else {
                console.log("unknown sensor %s", name)
            }
        })
    }

    fetch(url) {
        let that = this
        fetchSrc(url, text => {
            // Re-configure the outer SVG to match the inner imported SVG
            let importedSvg = that.#drawing.svg(text).children()[1]
            importedSvg.attr('preserveAspectRatio', 'xMidYMin meet')
            that.#drawing.viewbox(importedSvg.viewbox())
            let hexagonGroup = importedSvg.group().attr('id', 'HeatMap')
            let gridGroup = hexagonGroup.group().attr('id', 'HeatMapGrid')
            hexagonGroup.group().attr('id', 'HeatMapGridLabels')
            hexagonGroup.group().attr('id', 'HeatMapSensorGlyphs')

            // Create the color gradient legend
            createScaleLegend(that.#drawing.node.id)

            //
            this.findSensors()

            // Build the clip mask out of all the zone outlines
            let zones = that.#drawing.select('*[pl-type="zone"]')
            let clip = that.#drawing.clip()
            zones.each(function () {
                clip.add(this)
            })

            // Determine the hexagon grid parameters that covers the entire SVG
            //
            // The width is fixed, and everything is determined from that single measurement
            //
            // TODO: This really doesn't work properly, the geometry is off
            let bbox = that.#drawing.bbox()
            let aspectRatio = bbox.width / bbox.height
            let hexGridWidth = that.#gridWidth
            let hexagonSize = bbox.width / hexGridWidth
            let hexGridHeight = Math.floor(1.1547005 * hexGridWidth / aspectRatio)

            //    console.log("aspectRatio %f", aspectRatio)
            //    console.log("hexagonSize %f", bbox.width / hexGridWidth)
            //    console.log("hex grid = %d x %d", hexGridWidth, hexGridHeight)

            let t0 = performance.now()
            this.#hexagons = that.draw(gridGroup, hexagonSize, hexGridWidth, hexGridHeight)
            let t1 = performance.now()
            console.log("Heatmap update took " + (t1 - t0).toFixed(1) + " ms")
            hexagonGroup.clipWith(clip)
            //        tweakSensorValues()
            //        updateHexHeatmap(hexagonGroup, hexagons, Object.values(sensors), cycle)

            //        tweakAndUpdate(2000, 1000)
        }).then(() => {
            this.addSensorGlyphs()
            this.update()
        })
    }

    randomizeSensorValues(minValue, maxValue) {
        const delta = maxValue - minValue
        for (const name in this.#sensors) {
            let sensor = this.#sensors[name]
            if (sensor.value !== null) {
                sensor.value = delta * Math.random() + minValue
            }
        }
        this.update()
    }

    tweakSensorValues() {
        this.#sensors["MasterBedroomFloorTemperature"].value   = sineWave(this.#animationCycleCount, 15, 1/13., 0, 75)
        this.#sensors["MasterBedroomCeilingTemperature"].value = sineWave(this.#animationCycleCount, 15, 1/29., 0, 75)
        this.#sensors["StudyAirTemperature"].value             = sineWave(this.#animationCycleCount, 15, 1/41., 0, 75)
        this.#sensors["GreatRoomCeilingTemperature"].value     = sineWave(this.#animationCycleCount, 15, 1/53., 0, 75)
        this.#sensors["GreatRoomAirTemperature"].value         = sineWave(this.#animationCycleCount, 15, 1/79., 0, 75)
        this.#sensors["GreatRoomFloorTemperature"].value       = sineWave(this.#animationCycleCount, 15, 1/97., 0, 75)
    }

    draw(svg, hexagonSize, hexGridWidth, hexGridHeight) {
        const Hex = Honeycomb.extendHex({
            size: hexagonSize / 1.51,
            orientation: this.#gridStyle
        })
        const Grid = Honeycomb.defineGrid(Hex)
        const corners = Hex().corners()
        let that = this

        // Pre-compile the zone segments for later hit testing
        let zones = []
        this.#drawing.select('*[pl-type="zone"]').each(function () {
            zones.push(pointInSvgPolygon.segments(this.attr("d")))
        })

        // Draw the hexagonal grid
        let hexagons = []
        Grid.rectangle({ width: hexGridWidth, height: hexGridHeight }).forEach(hex => {
            const { x, y } = hex.toPoint()
            const center = hex.center()
            const cx = center.x + x
            const cy = center.y + y

            // Determine if the current hexagon will fall in any of the zones
            let isIn = false
            let hexagonPoints = corners.map(p => [p.x + x, p.y + y])
            hexagonPoints.forEach(point => {
                zones.forEach(zone => {
                    if (pointInSvgPolygon.isInside(point, zone)) {
                        isIn = true
                        return
                    }
                })
                if (isIn) {
                    return
                }
            })

            if (isIn) {
                let hexSymbol = svg.polygon(corners.map(({ x, y }) => `${x},${y}`))
                    .stroke({ width: 0.5, color: 'white' })
                    .fill('black')
                    .opacity(0.5)
                    .translate(x, y)
                    .attr('id', "hex_" + hex.x + "_" + hex.y)
                    .attr('pl-type', "hexagon")
                let closestSensors = closest(cx, cy, Object.values(that.#sensors), 3)
                hexagons.push({cx: cx, cy: cy, element: hexSymbol, closest: closestSensors})
            }

            const drawCenterMarker = false
            if (drawCenterMarker) {
                let radius = 1.0
                this.#drawing.circle(radius)
                    .fill('black')
                    .translate(cx - (radius / 2.0), cy - (radius / 2.0))
            }
        })
        return hexagons
    }

    delHexagonLabels() {
        let allText = this.#drawing.select('text[pl-type="label"]')
        allText.each(function () {
            this.remove()
        })
    }

    addHexagonLabels() {
        if (!heatmap.gridLabelsEnabled) {
            return
        }
        let that = this
        let hexagonGroup = this.#drawing.select('#HeatMapGridLabels').first()
        this.#hexagons.forEach((hexagon) => {
            // Label each hexagon with the value
            let hexagonId = hexagon.element.id()
            let value = this.#interpolatedValues[hexagonId]
            hexagonGroup.plain(value.toFixed(1))
                .attr("pl-type", "label")
                .font({
                    'font-size': 'x-small',
                    'dominant-baseline': 'central',
                    anchor: 'middle'
                })
                .translate(hexagon.cx, hexagon.cy)
        })
    }

    scaleValue(value, minValue, maxValue) {
        let delta = maxValue - minValue
        let scaledValue = Math.min(1.0, Math.max((value - minValue) / delta, 0.0))
        return scaledValue
    }

    scaleColor(value, minValue, maxValue) {
        let scaledValue = this.scaleValue(value, minValue, maxValue)
        let color = scale(scaledValue).hex()
        return color
    }

    interpolate() {
        let that = this
        this.#hexagons.forEach(hexagon => {
            let hexagonId = hexagon.element.id()
            let value = inverseDistanceWeighting(hexagon, Object.values(that.#sensors), heatmap.interpolatePower)
            that.#interpolatedValues[hexagon.element.id()] = value
        })
    }

    addHexagonColors() {
        let that = this
        this.#hexagons.forEach(hexagon => {
            let hexagonId = hexagon.element.id()
            let value = this.#interpolatedValues[hexagonId]
            let color = this.scaleColor(value, 60.0, 90.0)
            if (this.gridAnimateColorsEnabled) {
                hexagon.element.animate(that.#animationDuration, '-', 0).fill(color)
            }
            else {
                hexagon.element.fill(color)
            }
        })
    }

    delHexagonColors() {
        this.#hexagons.forEach(hexagon => {
            hexagon.element.fill('none')
        })
    }

    update() {
        let t0 = performance.now()

        let that = this
        this.delHexagonLabels()
        this.delSensorGlyphs()

        this.interpolate()
        if (heatmap.gridColorsEnabled) {
            this.addHexagonColors()
        }
        else {
            this.delHexagonColors()
        }

        if (this.sensorGlyphsEnabled) {
            this.addSensorGlyphs()
        }
        if (this.gridLabelsEnabled) {
            this.addHexagonLabels()
        }

        let t1 = performance.now()
        console.log("Heatmap update took " + (t1 - t0).toFixed(1) + " ms")
    }

    startUpdates(mode) {
        this.stopUpdates()
        if (mode == "live") {
            if (this.jobId === null) {
                this.jobId = setInterval(function() {
                    getLiveData()
                        .then((newValues) => {
                            if (heatmap.updateSensors(newValues)) {
                                heatmap.update()
                            }
                        })
                        .catch(error => { console.log("unable to fetch data %O", error) })
                }, this.liveUpdatePeriod)
            }
        }
        else if (mode == "random") {
            if (this.jobId === null) {
                this.jobId = setInterval(function() {
                    heatmap.randomizeSensorValues(60.0, 90.0)
                }, this.liveUpdatePeriod)
            }
        }
        else if (mode == "none") {
            return
        }
    }

    stopUpdates() {
        if (this.jobId !== null) {
            clearInterval(this.jobId)
            this.jobId = null
        }
    }

    startAnimation(cycleTime=2000, numCycles=10) {
        console.log("starting animation")

        this.tweakSensorValues()
        this.update()

        let that = this
        this.#animationCycleCount += 1
        sleep(cycleTime).then(() => {
            if (that.#animationCycleCount < numCycles) {
                that.startAnimation(cycleTime, numCycles)
            }
        });
    }

    stopAnimation() {
    }
}

let jobId = null
let heatmap = null
export default {
    components: {
    },
    created: function() {
    },
    mounted: function () {
        let url = require("@/assets/comanche_main.svg")
        heatmap = new Heatmapper('main')
        heatmap.sensorGlyphsEnabled = false
        heatmap.gridLabelsEnabled = false
        heatmap.gridColorsEnabled = true
        heatmap.fetch(url)
    },
    data() {
        return {
            right: false,
            sensorGlyphsEnabled: false,
            gridLabelsEnabled: false,
            gridColorsEnabled: true,
            gridAnimateColorsEnabled: false,
            liveUpdatePeriod: 3000,
            gridWidth: 50,
            gridStyle: "flat",
            gridStyleOptions: ["flat", "pointy"],
            liveDataSource: "none",
            liveDataSourceOptions: ["none", "random", "live"],
            interpolatePower: 1.5,
            liveDataEnabled: false
        }
    },
    methods: {
        onAnimateColorsStateChanged: function(val) {
            heatmap.gridAnimateColorsEnabled = val
        },
        onLiveDataSourceChanged: function(val) {
            heatmap.startUpdates(val)
        },
        onLiveUpdatePeriodChanged: function(val) {
            if (val < 3000) {
                val = 3000
            }
            heatmap.liveUpdatePeriod = val
        },
        onRandomizeSensorData: function() {
            heatmap.randomizeSensorValues(60.0, 90.0)
        },
        onInterpolatePowerChanged: function(val) {
            heatmap.interpolatePower = val
            if (heatmap.gridColorsEnabled) {
                heatmap.update()
            }
        },
        onColorStateChanged: function(val) {
            heatmap.gridColorsEnabled = val
            if (val) {
                heatmap.addHexagonColors()
            }
            else {
                heatmap.delHexagonColors()
            }
        },
        onLabelStateChanged: function(val) {
            heatmap.gridLabelsEnabled = val
            if (val) {
                heatmap.addHexagonLabels()
            }
            else {
                heatmap.delHexagonLabels()
            }
        },
        onGlyphStateChanged: function(val) {
            heatmap.sensorGlyphsEnabled = val
            if (val) {
                heatmap.addSensorGlyphs()
            }
            else {
                heatmap.delSensorGlyphs()
            }
        }
    }
}

